import { render } from "./pr_dashboard.vue?vue&type=template&id=372d4745&scoped=true"
import script from "./pr_dashboard.vue?vue&type=script&lang=js"
export * from "./pr_dashboard.vue?vue&type=script&lang=js"

import "./pr_dashboard.vue?vue&type=style&index=0&id=372d4745&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-372d4745"]])

export default __exports__